import { useEffect, useState } from 'react';

export const useScrollDirection = (initialValue = 0) => {
  const [lastScroll, setLastScroll] = useState(0);
  const [direction, setDirection] = useState(initialValue);

  useEffect(() => {
    const updateHidden = () => {
      const newDirection = Math.sign(window.pageYOffset - lastScroll);
      setLastScroll(window.pageYOffset);
      if (newDirection === direction) {
        return;
      }

      setDirection(newDirection);
    };

    window.addEventListener('scroll', updateHidden);

    return () => window.removeEventListener('scroll', updateHidden);
  });

  return direction;
};
